export const VISITED_ARTICLES = 'visitedArticles';
export const VIEWED_ARTICLES = 'viewedArticles';
export const VISITED_LESSONS = 'visitedLessons';
export const VISITED_COURSES = 'visitedCourses';
export const PRO_MAIN_PAGE_VISITS = 'proMainPageVisits';

export const AUTH_POPUP_URL_PARAM = 'show-login-popup';
